// extracted by mini-css-extract-plugin
export default {"projectsPage":"ProjectsPage_projectsPage__uAEW0","projectsGrid":"ProjectsPage_projectsGrid__REgfp","project":"ProjectsPage_project__Icnyd"};